import { Flex as NbFlex } from '@fhs-legacy/native-base';

import { addWithConfig } from '../../utils';

export const Flex = NbFlex;

export default addWithConfig(Flex);
